import React, { useRef, useState } from "react";
import ActionItemsDateRangePicker from "./ActionItemsDateRangePicker";

const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatShortDate = (iso) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return "";
  const [year, month, day] = iso.split("-").map(Number);
  const label = `${MONTH_SHORT[month - 1]} ${day}`;
  return year === new Date().getFullYear() ? label : `${label}, ${year}`;
};

const ActionItemsEventDateFilter = ({ from, to, onChange, onClear, className = "" }) => {
  const wrapRef = useRef(null);
  const [pickerOpen, setPickerOpen] = useState(false);

  const fromLabel = formatShortDate(from);
  const toLabel = formatShortDate(to);
  const rangeLabel = fromLabel && toLabel
    ? `${fromLabel} – ${toLabel}`
    : fromLabel || toLabel || "Select range";

  return (
    <div
      className={["action-items-date-filter", "action-items-date-filter--active", className]
        .filter(Boolean)
        .join(" ")}
      ref={wrapRef}
    >
      <button
        type="button"
        className="action-items-date-filter__clear action-items-active-filter__clear"
        onClick={onClear}
        aria-label="Clear event date filter"
        title="Clear event date filter"
      >
        ×
      </button>
      <span className="action-items-date-filter__label">Event date</span>
      <button
        type="button"
        className="action-item-due-badge"
        onClick={() => setPickerOpen((open) => !open)}
        aria-label="Edit event date range"
        title="Edit event date range"
      >
        {rangeLabel}
      </button>
      {pickerOpen ? (
        <ActionItemsDateRangePicker
          anchorRef={wrapRef}
          from={from}
          to={to}
          onChange={(newFrom, newTo) => {
            onChange(newFrom, newTo);
            if (!newFrom && !newTo) onClear();
          }}
          onClose={() => setPickerOpen(false)}
        />
      ) : null}
    </div>
  );
};

export default ActionItemsEventDateFilter;
